// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v40C","top":"styles_top__8_dl_","left":"styles_left__3ImLk","description":"styles_description__1oEAT"};